import React from "react";
import { cn } from "../../lib/utils";

const SectionHeader = ({
  title,
  description = "",
  icon: Icon = null,
  actions = null,
  eyebrow = "",
  className = "",
}) => (
  <div
    className={cn(
      "flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between",
      className,
    )}
  >
    <div className="flex min-w-0 items-start gap-3">
      {Icon && (
        <span
          className="mt-0.5 inline-flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-xl bg-primary-50 text-primary-700 ring-1 ring-inset ring-primary-100 dark:bg-primary-950/40 dark:text-primary-300 dark:ring-primary-900/50"
          aria-hidden="true"
        >
          <Icon size={18} />
        </span>
      )}
      <div className="min-w-0">
        {eyebrow && (
          <p className="mb-1 text-[11px] font-semibold uppercase tracking-wide text-primary-700 dark:text-primary-300">
            {eyebrow}
          </p>
        )}
        <h2 className="text-base font-bold text-neutral-900 dark:text-neutral-50">
          {title}
        </h2>
        {description && (
          <p className="mt-1 max-w-3xl text-sm leading-6 text-neutral-500 dark:text-neutral-400">
            {description}
          </p>
        )}
      </div>
    </div>
    {actions && (
      <div className="flex flex-wrap items-center gap-2 sm:justify-end">
        {actions}
      </div>
    )}
  </div>
);

export default SectionHeader;
